export interface TourStep {
  emoji: string;
  title: string;
  body: string;
  hint?: string;
}

export interface TourDefinition {
  route: string;
  targetId: string;
  spotlightPadding?: number;
  spotlightClickable?: boolean;
  steps: TourStep[];
}

export const TOUR_REGISTRY: Record<string, TourDefinition> = {
  'subscription-management-v1': {
    route: '/dashboard',
    targetId: 'credit-summary-card',
    spotlightPadding: 8,
    spotlightClickable: true,
    steps: [
      {
        emoji: '⚡',
        title: 'Your membership, simplified',
        body: 'You can now also upgrade or downgrade your membership!',
      },
    ],
  },
  'credits-v1': {
    route: '/dashboard',
    targetId: 'credit-summary-card',
    spotlightPadding: 8,
    spotlightClickable: true,
    steps: [
      {
        emoji: '✨',
        title: 'Your profile got a fresh look!',
        body: 'We made it easier to see your credits at a glance.',
      },
      {
        emoji: '🪙',
        title: 'Your credits, front and center',
        body: 'Credits from your packs and memberships, all in one spot.',
      },
      {
        emoji: '👆',
        title: 'Tap the card for details',
        body: 'Status, price, renewal/expiration date — tap the card to see it all.',
      },
    ],
  },
};
